import styled from 'styled-components';
import {
  supportLemonGreen,
  brandBlack,
  supportOliveGreen,
  supportDarkGreen,
  neutralBlueGray
} from 'src/utilities/UIStyles/variables/Colors';

export const AvisoContainer = styled.div`
  font-family: 'IBM Plex Sans', sans-serif;
  margin: 5% 0;
  border-radius: 5px;
  opacity: 0.8;
  padding: 1% 3%;
  & > p {
    margin: 0 3%;
    color: black;
    font-size: 1vw;
    & > a {
      color: ${supportOliveGreen};
      font-weight: bold;
      font-size: 1.2vw;
    }
  }
  & > h2 {
    color: ${supportLemonGreen};
    text-align: center;
    font-weight: 600;
    font-size: 1.5vw;
  }
  & > h1 {
    color: ${supportLemonGreen};
    text-align: center;
    font-weight: 700;
    margin: 0 3%;
    padding: 2% 0;
  }
  & > h3 {
    color: ${supportDarkGreen};
    margin: 0 3%;
    font-weight: 600;
  }
  & > ul {
    padding: 2% 5%;
    & > p {
      color: ${neutralBlueGray};
      padding: 0;
      font-weight: bold;
      font-size: 1vw;
    }
    & > li {
      & > span {
        color: ${brandBlack};
        text-align: center;
        font-weight: 600;
        font-size: 1vw;
      }
    }
  }
`;

export const Logo = styled.div`
  display: flex;
  width: 100%;
  margin: 1% 0 0 80%;
`;
